import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { cx } from '../../utils/cx';
import s from './VisuallyHidden.module.css';

export type VisuallyHiddenProps = ComponentPropsWithoutRef<'span'> & { as?: ElementType };

/** Content for screen readers only. */
export function VisuallyHidden({ as: Tag = 'span', className, ...rest }: VisuallyHiddenProps) {
  return <Tag className={cx(s.hidden, className)} {...rest} />;
}
